import { render, staticRenderFns } from "./RemindersNotification.vue?vue&type=template&id=01f89359"
import script from "./RemindersNotification.vue?vue&type=script&lang=js"
export * from "./RemindersNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports